export default (payload) => ({
  type: 'UPDATE_CUSTOMER_STATE',
  payload,
});
